import React from 'react';
import {useTranslation} from 'react-i18next';
import {Dialog, DialogContent, DialogFooter, Button} from '@taopix/taopix-design-system';

export type ThemeConfirmDialogProps = {
  open: boolean;
  onConfirm: (event: React.MouseEvent) => void;
  onCancel: (event: React.MouseEvent) => void;
  canConfirm: boolean;
};

const ThemeConfirmDialog = ({open, canConfirm, onCancel, onConfirm}: ThemeConfirmDialogProps) => {
  const {t} = useTranslation();

  return (
    <Dialog
      id={'themeSwitch-confirm'}
      open={open}
      width={800}
      title={t('*:str_TitleWarning')}
      showTitle={false}
    >
      <DialogContent>
        {t('toolpalette:str_LabelThemeSwitchWarning')
          .split('<br />')
          .map((str, index) => {
            return <p key={index}>{str}</p>;
          })}
      </DialogContent>
      <DialogFooter>
        <Button
          label={t('*:str_ButtonClose')}
          onClick={(event: React.MouseEvent) => onCancel(event)}
          buttonStyle="negative"
        />
        <Button
          label={t('*:str_ButtonOK')}
          buttonStyle="primary"
          onClick={(event: React.MouseEvent) => onConfirm(event)}
          disabled={canConfirm}
        />
      </DialogFooter>
    </Dialog>
  );
};

export default ThemeConfirmDialog;
